import * as React from "react";
import { Fields } from "redux-form";

import DimensionField from "./DimensionField";
import PageNumberField from "./PageNumberField";
import TitleField from "./TitleField";
import ContentField from "./ContentField";
import IndustryField from "./IndustryField";
import MaterialField from "./MaterialField";
import AudienceField from "./AudienceField";
import ColorField from "../../WizardColorChoice";
import { ProjectInfoFormProps } from "./ProjectInfoForm";

interface FieldSwitchProps extends ProjectInfoFormProps {
  shouldRenderField: (att: number) => boolean;
}

const ProjectInfoFormFieldSwitch = (props: FieldSwitchProps) => (
  <div>
    {props.shouldRenderField(props.chosenProduct.attribute.industry) && (
      <IndustryField {...props} />
    )}
    {props.shouldRenderField(props.chosenProduct.attribute.dimension) && (
      <DimensionField {...props} />
    )}
    {props.shouldRenderField(props.chosenProduct.attribute.page_number) && (
      <PageNumberField {...props} />
    )}
    {props.shouldRenderField(props.chosenProduct.attribute.title) && (
      <TitleField {...props} />
    )}
    {props.shouldRenderField(props.chosenProduct.attribute.content) && (
      <ContentField {...props} />
    )}
    {props.shouldRenderField(props.chosenProduct.attribute.material) && (
      <MaterialField {...props} />
    )}
    {props.shouldRenderField(props.chosenProduct.attribute.primary_color) && (
      <Fields
        names={["primary_color", "secondary_color"]}
        component={ColorField}
      />
    )}
    {props.shouldRenderField(props.chosenProduct.attribute.audience) && (
      <AudienceField {...props} />
    )}
  </div>
);

export default ProjectInfoFormFieldSwitch;



// WEBPACK FOOTER //
// ./src/routes/Step4/components/ProjectInfoFormFieldSwitch.tsx